import { Provider } from '@angular/core';
import { PACOTE_DOSSIE_REPOSITORY } from './repositories/pacote-dossie.repository';
import { PacoteDossieService } from './services/pacote-dossie.service';

export const PACOTE_DOSSIE_PROVIDERS: Provider[] = [
  {
    provide: PACOTE_DOSSIE_REPOSITORY,
    useClass: PacoteDossieService
  }
];


